import {ViewStream} from 'spyne';
import hljs from "highlight.js";

import CustomItemsTmpl from './templates/code-container-properties-content-custom-items.tmpl.html';
export class CodeContainerPropertiesContentCustomItems extends ViewStream {

    constructor(props={}) {
        props.class = 'code-container-properties-content__custom-items return-content';

        console.log('custm content data ',props.data);
        props.template = CustomItemsTmpl;
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onRendered() {


    }

}

